module.exports = __webpack_public_path__ + "img/Ramunas_B.051d705b.jpg";